import { trackPendoEvent } from 'utils/pendo'

/** Pendo Track Events for PsimA LA/GA product metrics (see `.claude/skills/psima-product-metrics`). */
export const PSIMA_PENDO_EVENTS = {
  PAGE_VIEW: 'psima.page.view',
  SIMULATION_LAUNCH: 'psima.simulation.launch',
  EMAIL_PREVIEW_OPEN: 'psima.email_preview.open',
  CARD_SELECT: 'psima.card.select',
  CARD_DESELECT: 'psima.card.deselect',
  PARTICIPANT_EDIT: 'psima.participant.edit',
  REMEDIATION_FILTER: 'psima.remediation_filter',
  FEEDBACK_SUBMITTED: 'psima.feedback.submitted',
}

/**
 * Stable `data-pendo-feature` values for Feature tagging
 * (see `ui/.ai/skills/pendo-feature-marking.md`).
 */
export const PSIMA_PENDO_FEATURES = {
  SIDEBAR_DASHBOARD: 'psima-sidebar-dashboard',
  SIDEBAR_LAUNCHED: 'psima-sidebar-launched',
  DASHBOARD_QUICK_LAUNCH: 'psima-dashboard-quick-launch',
  DASHBOARD_LAUNCH_SIMULATION: 'psima-dashboard-launch-simulation',
  DASHBOARD_QUICK_LAUNCH_GENERATE: 'psima-dashboard-quick-launch-generate',
  DASHBOARD_CARD_SELECT: 'psima-dashboard-card-select',
  DASHBOARD_PARTICIPANT_TOGGLE: 'psima-dashboard-participant-toggle',
  DASHBOARD_FEEDBACK_UP: 'psima-dashboard-feedback-up',
  DASHBOARD_FEEDBACK_DOWN: 'psima-dashboard-feedback-down',
  DASHBOARD_REMEDIATION_FILTER: 'psima-dashboard-remediation-filter',
  LAUNCHED_EMAIL_PREVIEW: 'psima-launched-email-preview',
  LAUNCHED_FEEDBACK_UP: 'psima-launched-feedback-up',
  LAUNCHED_FEEDBACK_DOWN: 'psima-launched-feedback-down',
}

export const trackPsimaPageView = (page) => {
  trackPendoEvent(PSIMA_PENDO_EVENTS.PAGE_VIEW, { page })
}

/**
 * One Track Event per successfully launched simulation (not per batch click).
 *
 * Metric contracts:
 * - Zero-edit / audit preview joins: count events (= sims); use simulation_id + is_zero_edit
 * - TTFL: first event timestamp per account
 * - Active Clients: distinct account with ≥1 launch event (do not sum events)
 *
 * batch_size is context only (successful sims in this launch request), not a denom.
 */
export const trackPsimaSimulationLaunch = ({
  simulationId,
  launchSource,
  batchSize,
  isZeroEdit,
}) => {
  trackPendoEvent(PSIMA_PENDO_EVENTS.SIMULATION_LAUNCH, {
    simulation_id: simulationId,
    launch_source: launchSource,
    batch_size: batchSize,
    is_zero_edit: isZeroEdit,
  })
}

export const trackPsimaEmailPreviewOpen = ({ simulationId }) => {
  trackPendoEvent(PSIMA_PENDO_EVENTS.EMAIL_PREVIEW_OPEN, {
    simulation_id: simulationId,
  })
}

export const trackPsimaCardSelection = ({ selected }) => {
  trackPendoEvent(selected ? PSIMA_PENDO_EVENTS.CARD_SELECT : PSIMA_PENDO_EVENTS.CARD_DESELECT)
}

export const trackPsimaParticipantEdit = () => {
  trackPendoEvent(PSIMA_PENDO_EVENTS.PARTICIPANT_EDIT, {
    edit_initiator: 'admin',
  })
}

export const trackPsimaRemediationFilter = ({ filter }) => {
  trackPendoEvent(PSIMA_PENDO_EVENTS.REMEDIATION_FILTER, { filter })
}

export const trackPsimaFeedbackSubmitted = ({ target, reviewSide }) => {
  trackPendoEvent(PSIMA_PENDO_EVENTS.FEEDBACK_SUBMITTED, {
    target,
    review_side: reviewSide,
  })
}
